import { FormInstance, Row } from 'antd'
import React, { FunctionComponent } from 'react'
import { useCustomFieldsContext } from '../../../../context/customFields'
import { FieldTargetType } from '../../../../context/types'
import CustomField from '../../../helpers/CustomField/CustomField'

type TProps = {
	form: FormInstance
}

const OnboardingCustomFields: FunctionComponent<TProps> = ({ form }) => {
	const { customFields } = useCustomFieldsContext()

	return (
		<div className="onboarding-step">
			<Row gutter={[50, 0]}>
				{customFields[FieldTargetType.onboarding].fields.map((field) => (
					<CustomField field={field} form={form} desktopSpan={12} key={field.name} />
				))}
			</Row>
		</div>
	)
}

export default OnboardingCustomFields
